import { GET_LOGOUT_SUCCESS } from "./actionTypes";

const initialState = {
    data: {},
};

const logoutR = (state = initialState, action) => {
    
    switch (action.type) {
        case GET_LOGOUT_SUCCESS:
            state = { ...state, data: action.payload.response };
            return state;
    }
    return state;
}

export default logoutR